import moduleConfig from "./contact.config";

export default [
  {
    path: moduleConfig.basePath,
    component: () => import("./contact.module"),
    children: [
      {
        path: '/',
        name: 'Contact',
        component: () => import("./views/contact"),
      },
    ],
  },
];

